module.exports = __webpack_public_path__ + "img/sld_mfm_inv_14_t1_b1_dark.ad944d61.svg";